import { render, staticRenderFns } from "./guanghua.vue?vue&type=template&id=abff9b94"
import script from "./guanghua.vue?vue&type=script&lang=ts"
export * from "./guanghua.vue?vue&type=script&lang=ts"
import style0 from "./guanghua.vue?vue&type=style&index=0&id=abff9b94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports